module.exports = __webpack_public_path__ + "img/v4_h7.d4a3d86f.png";